import { getQueryString, handleError } from "../apiUtils";
import axios from "../axios";

export async function getIUCNStatus() {
  try {
    const resp = await axios.get("/api/iucnstatus/?pageSize=30");
    return resp.data;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function createNewStatus(newstatus: object) {
  try {
    const resp = await axios.put("/api/iucnstatus/create/", newstatus);
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function updateStatus(iucnstatus: object) {
  try {
    const resp = await axios.post("/api/iucnstatus/update/", iucnstatus);
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function deleteStatus(status_id: string) {
  try {
    const resp = await axios.delete("/api/iucnstatus/delete?id=" + status_id);
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}
